export default {"src":"/_next/static/media/genussfestival-logo-small.d07604d1.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};